import DashboardStatusCard from './DashboardStatusCard';

export default DashboardStatusCard;
